/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ImageMachine } from "abreact/internal/imageFinder/ImageMachine";
import { AbFilterUtils } from "abreact/utils/AbFilterUtils";
import { AbWebServices } from "abweb/service/AbWebServices";
/**
 * Fetches image identifiers filtered by namespace and custom filter function
 * Excludes litebrite images, deprecated images, and ab excluded namespaces
 * @param filterFunction - Optional filter function to further filter the images
 * @returns Array of ImageIdentifierInfo objects that pass the filters
 */
export const fetchIcons = filterFunction => {
  try {
    const allIdentifiers = AbWebServices.getImageIdentifierManager().getImageIdentifierService().getAllIdentifiers();

    // Filter the identifiers with a single filter function
    return allIdentifiers.filter(image => {
      // Exclude litebrite namespace and deprecated images
      // Exclude all the non-absdk in-house namespaces
      if (image.namespace === "litebrite" || image.extra?.flags.includes("deprecated") || ImageMachine.isExcludedNamespace(image.namespace)) {
        return false;
      }
      return filterFunction ? filterFunction(image) : true;
    });
  } catch (error) {
    console.error('Error fetching image identifiers:', error);
    throw error;
  }
};

/**
 * Checks if an icon matches a search term by its semantic name (if available) or display name or visual element
 * Not case-sensitive
 * @param searchTerm - Text to search for
 * @param image - The image identifier info to check
 * @returns True if the icon matches the search term
 */
export function matchIconToSearchTerm(searchTerm, image) {
  // Check semantic name first if available, then use the identifier, then check visual elements
  const matchTerms = [image.extra?.semanticName, image.fullId, ...[image.extra?.visualElement ?? []]].filter(Boolean);
  return matchTerms.some(term => AbFilterUtils.FILTER_FUNCTIONS.SUBSTRING(searchTerm, term));
}
//# sourceMappingURL=IconUtils.js.map
